module.exports = __webpack_public_path__ + "static/media/BCT168.1d936b5b.png";